// extracted by mini-css-extract-plugin
export default {"row":"TemplateRow_row__Mh4iJ","name":"TemplateRow_name__upZlC","type":"TemplateRow_type__shcx0","actions":"TemplateRow_actions__Lcudu"};